var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-footer", { staticClass: "justify-center" }, [
    _c("span", [_vm._v(_vm._s(_vm.$t("footer")))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }